import { SEGMENT_LAYOUT, hoverDaFaixa, marcaDaBarra } from "../../gantt-fornecedor.utils";
import { ConflictBand } from "@/shared/components/conflict-band";
import { AllocationBar } from "@/shared/components/gantt-allocation-bar";
import { GanttFornecedorBarraObra } from "../gantt-fornecedor-barra-obra";
import type { GanttFornecedorConteudoProps } from "./types-gantt-fornecedor-conteudo";
import styles from "@/shared/components/gantt-carga/gantt.module.scss";

export function GanttFornecedorConteudoView({
  row,
  variant,
  marcas,
  onConflictHover,
  onConflictLeave,
}: GanttFornecedorConteudoProps) {
  return (
    <>
      {row.bands.map((band) =>
        // Conflito tratado (HU 2041): faixa verde que abre o card "Conflito ignorado" (Figma 10779:215287), como em Profissionais e Local.
        band.ignored && band.groups && band.groups.length > 0 ? (
          <ConflictBand
            key={band.key}
            groups={band.groups}
            tratado
            left={band.left}
            width={band.width}
            className={styles.conflictBandIgnored}
          />
        ) : (
          <span
            key={band.key}
            className={band.ignored ? styles.conflictBandIgnored : styles.conflictBand}
            style={{ left: `${band.left}%`, width: `${band.width}%` }}
            title={band.ignored ? band.tooltip : undefined}
            onMouseEnter={hoverDaFaixa(band, onConflictHover)}
            onMouseLeave={onConflictLeave}
            data-testid={band.ignored ? "gantt-conflict-band-ignored" : "gantt-conflict-band"}
          />
        ),
      )}
      {row.items.map((item) =>
        variant === "line" ? (
          <GanttFornecedorBarraObra
            key={item.key}
            item={item}
            marca={marcaDaBarra(marcas, item.key)}
          />
        ) : (
          <AllocationBar
            key={item.key}
            item={item}
            layout={SEGMENT_LAYOUT}
            marca={marcaDaBarra(marcas, item.key)}
            marcaPreenchida
            plainTitle
          />
        ),
      )}
    </>
  );
}
